import { darken } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

export const styles = makeStyles(() => ({
    modalContainer: {
        position: 'absolute',
        width: '390px',
        height: 'auto',
        borderRadius: '8px',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%)`,
        backgroundColor: '#fff',
        padding: '24px 32px',
    },
    displyingCenter: {
        padding: '0 18px 18px 18px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        '& >footer': {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-around',
        },
    },
    bodyContainer: {
        marginTop: '12px',
    },
    typography: {
        marginBottom: '18px',
        color: '#3A4B59',
    },
    title: {
        marginTop: '10px',
        fontSize: '19px',
        color: '#23323F',
        marginBottom: '16px',
        fontWeight: '500',
    },
    marginBottom: {
        marginBottom: 0,
    },
    button: {
        border: '1px solid #E4E6EB',
        boxShadow: 'none',
        borderRadius: '30px',
        fontWeight: 500,
        fontSize: '15px',
        padding: '15px 35px',
        height: '52px',
    },
    buttonRed: {
        backgroundColor: '#872336',
        color: '#FFFFFF',
        '&:hover': {
            backgroundColor: darken('#872336', 0.2),
            boxShadow: 'none',
        },
    },
    buttonGrey: {
        backgroundColor: '#E4E6EB',
        color: '#6B7985',
        '&:hover': {
            backgroundColor: darken('#E4E6EB', 0.1),
            boxShadow: 'none',
        },
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    icon: {
        height: '60px',
        width: '60px',
    },
}));
